package ru.it_mozaika.components

import mui.material.TablePagination
import mui.system.sx
import react.FC
import react.Props
import react.ReactNode
import react.dom.events.ChangeEvent
import react.dom.html.ReactHTML.div
import web.cssom.*
import web.html.HTMLElement

external interface TablePaginationProps: Props {
    var size: Int
    var handleChangePage: (Int) -> Unit
    var page: Int
    var handleChangeRowsPerPage: (ChangeEvent<HTMLElement>) -> Unit
    var currentRowsPerPageValue: Int
}

val tablePagination = FC<TablePaginationProps>{ props ->
    TablePagination {
        sx {

            maxHeight = 50.px
            border = 2.px
            borderColor = Color("#000000")
            this.alignItems = AlignItems.center
            this.justifyItems = JustifyItems.center
            this.justifyContent = JustifyContent.center
////            this.fontSize = FontSize.large
//                "& .MuiTablePagination-selectLabel"{
//                    this.fontSize = FontSize.large
//                }
//            "& .MuiTablePagination-displayedRows"{
//                this.fontSize = FontSize.large
//            }
        }
        rowsPerPageOptions = arrayOf(10, 25, 250)
        labelRowsPerPage = ReactNode("Показывать по...")
        component = div
        count = props.size
        this.rowsPerPage = props.currentRowsPerPageValue

        this.page = props.page

        onPageChange = { _, newPage ->
            props.handleChangePage(newPage.toInt())
        }
        onRowsPerPageChange = { event ->
            props.handleChangeRowsPerPage(event)
        }

    }
}